module.exports = __webpack_public_path__ + "static/img/elegantManners2.bbc52f51.png";